module.exports = __webpack_public_path__ + "static/media/16.64d96f3d.jpg";